import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { inject, NgModule } from '@angular/core';
import { ApolloClientOptions, ApolloLink, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { GraphqlAuthService } from './services/graphql-auth.service';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

const uri = environment.fraga.graphql;

export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {

  const authService = inject(GraphqlAuthService)

  const auth = setContext(async (_operation, context) => {
    const token = await firstValueFrom(authService.getToken());
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : ''
      }
    };
  });

  const http = httpLink.create({ uri, withCredentials: true });

  return {
    link: ApolloLink.from([auth, http]),
    cache: new InMemoryCache(),
  };
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink]
    }
  ]
})
export class GraphQLModule { }
